<script lang="ts">
    import {onMount} from "svelte";
    import SpaceAuthorityUserRowView from "./SpaceAuthorityUserRowView.svelte";

    export let spaceUsers;

    $: sortedSpaceUsers = (() => {
        if (spaceUsers == null) {
            return [];
        }

        const sortedSpaceUsers = spaceUsers.sort((a, b) => {
            const aAuthorityType = a.authority_type;
            const bAuthorityType = b.authority_type;
            if (aAuthorityType != bAuthorityType) {
                return bAuthorityType - aAuthorityType;
            }
            const aUser = a.user;
            const bUser = b.user;
            if (aUser == null) {
                return -1;
            }
            if (bUser == null) {
                return 1;
            }
            const aUserType = aUser.type;
            const bUserType = bUser.type;
            if (aUserType != bUserType) {
                return bUserType - aUserType;
            }
            const aUserCompanyName = aUser.company_name;
            const bUserCompanyName = bUser.company_name;
            if (aUserCompanyName !== bUserCompanyName) {
                return aUserCompanyName.localeCompare(bUserCompanyName);
            }
            const aUserDepartmentName = aUser.department_name;
            const bUserDepartmentName = bUser.department_name;
            if (aUserDepartmentName !== bUserDepartmentName) {
                return aUserDepartmentName.localeCompare(bUserDepartmentName);
            }
            const aUserName = aUser.name;
            const bUserName = bUser.name;
            return aUserName.localeCompare(bUserName);
        });
        return sortedSpaceUsers;
    })();


    onMount(() => {
    });


</script>

<div class="space-user-area">
    <div class="title">ユーザー権限</div>

    <table>
        <thead>
        <tr>
            <th>権限</th>
            <th>タイプ</th>
            <th>会社名 / 部署名 / 職種名</th>
            <th>名前</th>
        </tr>
        </thead>
        <tbody>
        {#each sortedSpaceUsers as spaceUser}
            <SpaceAuthorityUserRowView spaceUser={spaceUser}/>
        {/each}
        </tbody>
    </table>
</div>
<style lang="scss">
    .template-view {

    }
</style>